import { lazy } from 'react'
import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const NotasDeProduccionRegistro = lazy(() => import('./view/NoDeProRegistro'))
const NotasDeProduccionActualizar = lazy(() => import('./view/NoDeProActualizar'))
const NotasDeProduccionConsultar = lazy(() => import('./view/NoDeProConsultar'))
const NotasDeProduccionRectificar = lazy(() => import('./view/NoDeProRectificar'))
const NotasDeProduccionFinalizar = lazy(() => import('./view/NoDeProFinalizar'))
// const NotasDeProduccionIniciado = lazy(() => import('./view/NoDeProIniciado'))
const NdpIniciarGestion = lazy(() => import('./view/./NdpRegistrarGestion'))
const NdpCompletarGestion = lazy(() => import('./view/./NdpCompletarGestion.tsx'))
const NdpFinalizarGestion = lazy(() => import('./view/./NdpFinalizarGestion.tsx'))
const NdpConsultarGestion = lazy(() => import('./view/./NdpConsultarGestion.tsx'))

export const notasDeProduccionRoutesMap = {
  registro: {
    path: '/notasDeProduccion/registro',
    name: 'Nueva Producción',
    action: 'ADMINISTRAR',
  },
  registrarGestion: {
    path: '/notasDeProduccion/registro-gestion',
    name: 'Iniciar producción',
    action: 'INICIAR_PRODUCCION',
  },
  actualizar: {
    path: '/notasDeProduccion/actualizar/:id',
    name: 'Actualizar Producción',
    action: 'ADMINISTRAR',
  },
  iniciado: {
    path: '/notasDeProduccion/iniciado',
    name: 'Iniciar producción',
    action: 'INICIAR_N_PRODUCCION',
  },
  rectificar: {
    path: '/notasDeProduccion/rectificar/:id',
    name: 'Rectificar producción',
    action: 'RECTIFICAR',
  },
  completar: {
    path: '/notasDeProduccion/completar',
    name: 'Completar producción',
    action: 'ADMINISTRAR',
  },
  completadoGestion: {
    path: '/notasDeProduccion/completar-gestion',
    name: 'Completar producción',
    action: 'COMPLETAR_PRODUCCION',
  },
  finalizar: {
    path: '/notasDeProduccion/finalizar/:id',
    name: 'Finalizar producción',
    action: 'ADMINISTRAR',
  },
  finalizarGestion: {
    path: '/notasDeProduccion/finalizar-gestion',
    name: 'Finalizar producción',
    action: 'FINALIZAR_PRODUCCION',
  },
  consultar: {
    path: '/notasDeProduccion/consultar/:id',
    name: 'Consultar producción',
    action: 'CONSULTAR_PRODUCCION',
  },
  consultarGestion: {
    path: '/notasDeProduccion/consultar-gestion',
    name: 'Consultar producción',
    action: 'CONSULTAR_PRODUCCION',
  },
}
const notasDeProduccionRoutes = [
  {
    path: notasDeProduccionRoutesMap.consultarGestion.path,
    element: (
      <OperacionesProvider>
        <NdpConsultarGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.consultar.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionConsultar />
      </OperacionesProvider>
    ),
  },
  {
    path: notasDeProduccionRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionRegistro />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.registrarGestion.path,
    element: (
      <OperacionesProvider>
        <NdpIniciarGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.actualizar.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionActualizar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.rectificar.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionRectificar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.finalizar.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionFinalizar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.finalizarGestion.path,
    element: (
      <OperacionesProvider>
        <NdpFinalizarGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.completadoGestion.path,
    element: (
      <OperacionesProvider>
        <NdpCompletarGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default notasDeProduccionRoutes
